export const BTAX_ACCOUNT_WATCH_LIST_ITEM_TYPE = 'btax';